export enum COOKIE_EVENTS {
  COOKIEBOT_ON_ACCEPT = 'CookiebotOnAccept',
  COOKIEBOT_ON_DECLINE = 'CookiebotOnDecline',
}
